// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"DynamicDescription_wrapper__3M3iK","box":"DynamicDescription_box__1sSuy","p":"DynamicDescription_p__2Bnt2"};